var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45a5.625 5.625 0 0 0 5.625-5.625h-11.25A5.625 5.625 0 0 0 22.5 45zM22.5 5.395l-2.242.453c-5.14 1.038-9.008 5.584-9.008 11.027 0 1.766-.378 6.18-1.29 10.525-.454 2.157-1.06 4.403-1.865 6.35h28.81c-.805-1.947-1.411-4.193-1.864-6.35-.913-4.345-1.29-8.76-1.29-10.525 0-5.443-3.87-9.99-9.009-11.027L22.5 5.395zM39.992 33.75c.628 1.258 1.356 2.253 2.196 2.813H2.812c.84-.56 1.568-1.555 2.196-2.813 2.527-5.064 3.43-14.402 3.43-16.875 0-6.808 4.838-12.486 11.263-13.784a2.813 2.813 0 1 1 5.598 0c6.425 1.298 11.264 6.976 11.264 13.784 0 2.473.902 11.81 3.429 16.875z",
    fill: "#007DD2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBell);
export default __webpack_public_path__ + "static/media/new-bell.5623f0a4641d436decb20247e44db664.svg";
export { ForwardRef as ReactComponent };